<template>
  <h1>New Client</h1>
</template>

<script>
export default {};
</script>

<style></style>
